module.exports = __webpack_public_path__ + "static/media/mongo.0ebc1843.png";